const TZ = "America/Toronto";

function pad(n) { return String(n).padStart(2, "0"); }

// "2026-09-26" -> "20260926"
function compactDate(s) { return s.slice(0, 10).replace(/-/g, ""); }

// "2026-09-26T19:00:00" -> "20260926T190000"
function compactDateTime(s) {
  const [d, t = "00:00:00"] = s.split("T");
  const [hh = "00", mm = "00", ss = "00"] = t.split(":");
  return `${d.replace(/-/g, "")}T${pad(hh)}${pad(mm)}${pad(ss)}`;
}

// add days to a YYYY-MM-DD date, return compact YYYYMMDD (used for all-day exclusive end)
function addDaysCompact(s, days) {
  const dt = new Date(`${s.slice(0, 10)}T00:00:00`);
  dt.setDate(dt.getDate() + days);
  return `${dt.getFullYear()}${pad(dt.getMonth() + 1)}${pad(dt.getDate())}`;
}

export function hasSchedule(ev) {
  return Boolean(ev && ev.start);
}

// add days to a YYYY-MM-DD date, return ISO YYYY-MM-DD
function addDaysISO(s, days) {
  const dt = new Date(`${s.slice(0, 10)}T00:00:00`);
  dt.setDate(dt.getDate() + days);
  return `${dt.getFullYear()}-${pad(dt.getMonth() + 1)}-${pad(dt.getDate())}`;
}

export function outlookCalendarUrl(ev) {
  const params = new URLSearchParams();
  params.set("path", "/calendar/action/compose");
  params.set("rru", "addevent");
  params.set("subject", ev.title || "");
  if (ev.location) params.set("location", ev.location);
  if (ev.description) params.set("body", ev.description);
  if (ev.all_day) {
    params.set("allday", "true");
    params.set("startdt", ev.start.slice(0, 10));
    params.set("enddt", addDaysISO(ev.end || ev.start, 1)); // end exclusive
  } else {
    params.set("startdt", ev.start);
    params.set("enddt", ev.end || ev.start);
  }
  return `https://outlook.live.com/calendar/0/deeplink/compose?${params.toString()}`;
}

export function googleCalendarUrl(ev) {
  const params = new URLSearchParams();
  params.set("action", "TEMPLATE");
  params.set("text", ev.title || "");
  if (ev.location) params.set("location", ev.location);
  if (ev.description) params.set("details", ev.description);

  let dates;
  if (ev.all_day) {
    const start = compactDate(ev.start);
    const end = addDaysCompact(ev.end || ev.start, 1); // end exclusive
    dates = `${start}/${end}`;
  } else {
    const start = compactDateTime(ev.start);
    const end = compactDateTime(ev.end || ev.start);
    dates = `${start}/${end}`;
    params.set("ctz", TZ);
  }
  params.set("dates", dates);
  if (ev.rrule) params.set("recur", ev.rrule);
  return `https://calendar.google.com/calendar/render?${params.toString()}`;
}

export function buildIcs(ev) {
  const lines = [
    "BEGIN:VCALENDAR",
    "VERSION:2.0",
    "PRODID:-//Lagoon City Real Estate//Events//EN",
    "CALSCALE:GREGORIAN",
    "BEGIN:VEVENT",
    `UID:${ev.event_id || Math.random().toString(36).slice(2)}@lagooncityrealestate.ca`,
    `DTSTAMP:${new Date().toISOString().replace(/[-:]/g, "").split(".")[0]}Z`,
  ];
  if (ev.all_day) {
    lines.push(`DTSTART;VALUE=DATE:${compactDate(ev.start)}`);
    lines.push(`DTEND;VALUE=DATE:${addDaysCompact(ev.end || ev.start, 1)}`);
  } else {
    lines.push(`DTSTART;TZID=${TZ}:${compactDateTime(ev.start)}`);
    lines.push(`DTEND;TZID=${TZ}:${compactDateTime(ev.end || ev.start)}`);
  }
  if (ev.rrule) lines.push(ev.rrule.startsWith("RRULE:") ? ev.rrule : `RRULE:${ev.rrule}`);
  lines.push(`SUMMARY:${(ev.title || "").replace(/\n/g, " ")}`);
  if (ev.location) lines.push(`LOCATION:${ev.location.replace(/\n/g, " ")}`);
  if (ev.description) lines.push(`DESCRIPTION:${ev.description.replace(/\n/g, " ")}`);
  lines.push("END:VEVENT", "END:VCALENDAR");
  return lines.join("\r\n");
}

export function downloadIcs(ev) {
  const blob = new Blob([buildIcs(ev)], { type: "text/calendar;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = `${(ev.title || "event").replace(/[^a-z0-9]+/gi, "-").toLowerCase()}.ics`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}
